import * as React from "react";
import PropTypes from "prop-types";
import { DropTarget } from "react-dnd";
import ItemTypes from "./item-types";
import Icon from "../icon";

const boxTarget = {
  drop() {
    return {
      id: "DropZone",
      name: "DropZone",
    };
  },
};

export class DropZone extends React.Component {
  render() {
    return this.props.connectDropTarget ? (
      this.props.connectDropTarget(
        <div
          className={`border border-dark font-weight-bold text-light text-center p-5 bg-${
            this.props.canDrop && this.props.isOver ? "success" : "secondary"
          }`}
        >
          <Icon icon={this.props.canDrop && this.props.isOver ? "check-circle" : "plus"} />
        </div>,
      )
    ) : (
      <div>Not connected DropZone</div>
    );
  }
}

DropZone.propTypes = {
  canDrop: PropTypes.bool,
  isOver: PropTypes.bool,
  connectDropTarget: PropTypes.object,
};

export default DropTarget(ItemTypes.BOX, boxTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(DropZone);
